var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconTasks = function SvgIconTasks(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Button_Tasks|Stop-RightPanel"
  }, /*#__PURE__*/React.createElement("path", {
    id: "uuid-5072ea28-84a5-485f-9c7a-98944100d7c6",
    d: "M3.52647 1.41757L3.53874 1.41817H3.55101H12.441H12.4534L12.4658 1.41756C12.7801 1.40196 13.0539 1.64345 13.075 1.96294V11.0403C13.0538 11.3576 12.7823 11.6014 12.4656 11.5858L12.4533 11.5852H12.441H3.55101H3.53861L3.52623 11.5858C3.21192 11.6014 2.93817 11.3599 2.91699 11.0404V1.96309C2.93825 1.64573 3.20971 1.402 3.52647 1.41757Z",
    stroke: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-fbbb9ec8-5c4c-4956-9247-0ba4e9acdaeb",
    d: "M10.9837 13.911H1.79403C1.1477 13.911 0.624756 13.3868 0.624756 12.739V2.3435",
    stroke: "#262626",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-d8aee2c4-389a-4bda-93d6-1deb69edbd92",
    d: "M5.34888 6.36622L7.25262 8.40408L10.6371 4.77598",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconTasks);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-tasks.586a31e41468c317de776864efd46443.svg";